<div class="h-100 d-flex flex-column">
    <app-breadcrumb></app-breadcrumb>

    <div class="card mb-0 mt-3 flex-grow-1">
        <div class="card-body flex-column flex-nowrap" #containerCard>
            <div class="row">
                <!-- <div class="col-auto">
                    <div class="input-group input-group-sm">
                        <input type="text" class="form-control" placeholder="검색어"
                            [(ngModel)]="searchValue"
                            (keyup.enter)="keyupEnterSearchValue($event)">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-secondary"
                                (click)="clickSearch()">
                                <i class="fas fa-search"></i>
                                <span class="ml-1">
                                    검색
                                </span>
                            </button>
                        </div>
                    </div>
                </div> -->
                <div class="col-auto">
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedYear"
                        (ngModelChange)="changeYear($event)">
                        <option *ngFor="let item of listYear;" [ngValue]="item">{{item}} 년</option>
                    </select>
                </div>
                <div class="col-auto">
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedMonth"
                        (ngModelChange)="changeMonth($event)">
                        <option *ngFor="let item of listMonth;" [ngValue]="item">{{item}} 월</option>
                    </select>
                </div>
                <div class="col-auto">
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedMinDrive"
                        (ngModelChange)="changeMinDrive($event)">
                        <option [ngValue]="0">전체</option>
                        <option *ngFor="let item of listMinDrive;" [ngValue]="item">운행시간 {{item}} 분 미만 제외</option>
                    </select>
                </div>
                <div class="col-auto">
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedMinRest"
                        (ngModelChange)="changeMinRest($event)">
                        <option [ngValue]="0">전체</option>
                        <option *ngFor="let item of listMinRest;" [ngValue]="item">대기시간 {{item}} 분 미만 제외</option>
                    </select>
                </div>
                <div class="col"></div>
                <div class="col-auto">
                  <button type="button" class="btn btn-sm btn-info" (click)="clickSearch()">
                    <i class="fas fa-sync mr-1"></i>
                    불러오기
                  </button>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-outline-success"
                        (click)="exportExcel()">
                        <i class="fas fa-file-excel"></i>
                        <span class="ml-1">엑셀출력</span>
                    </button>
                </div>
            </div>

            <div class="table-responsive overflow-auto mt-3 flex-fill" #containerListRest
                [style.height]="heightContainerListRest + 'px'">
                <table class="table table-sm table-hover align-items-center text-nowrap mb-0">
                    <thead>
                        <tr class="text-center">
                            <th colspan="8">
                                운전자정보
                            </th>
                            <th colspan="4" class="border-left border-right">
                                운행정보
                            </th>
                            <th [attr.colspan]="maxDriveCnt * 2">
                                운행 및 휴게시간 내역(분)
                            </th>
                        </tr>
                        <tr class="text-center">
                            <th rowspan="2">
                                업체코드
                            </th>
                            <th rowspan="2">
                                운수종사자ID
                            </th>
                            <th rowspan="2">
                                업체명
                            </th>
                            <th rowspan="2">
                                생년월일
                            </th>
                            <th rowspan="2">
                                성명
                            </th>
                            <th rowspan="2">
                                입사일자
                            </th>
                            <th rowspan="2">
                                운송구분
                            </th>
                            <th rowspan="2">
                                노선번호 및 노선명(기점/종점)
                            </th>
                            <th rowspan="2">
                                시작일자
                            </th>
                            <th rowspan="2">
                                시작시간
                            </th>
                            <th rowspan="2">
                                종료일자
                            </th>
                            <th rowspan="2">
                                종료시간
                            </th>
                            <ng-template ngFor let-item [ngForOf]="listDriveCnt">
                                <th colspan="2" class="small border-left">
                                    {{item + 1}}회
                                </th>
                            </ng-template>
                        </tr>
                        <tr class="text-center small">
                            <ng-template ngFor let-item [ngForOf]="listDriveCnt">
                                <th class="border-left">
                                    운행(분)
                                </th>
                                <th>
                                    휴식(분)
                                </th>
                            </ng-template>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let itemRow of listRow;">
                            <tr class="text-nowrap text-center">
                                <td>
                                    {{itemRow.ccd}}
                                </td>
                                <td>
                                    {{itemRow.drvKotsaDriverId}}
                                </td>
                                <td>
                                    {{itemRow.companyNm}}
                                </td>
                                <td>
                                    {{itemRow.userBirthDt | filterDateTime:'yyyyMMdd'}}
                                </td>
                                <td>
                                    {{itemRow.userNm}}
                                </td>
                                <td>
                                    {{itemRow.userHireDt | filterDateTime:'yyyyMMdd'}}
                                </td>
                                <td>
                                    {{itemRow.dtgCarTypeNm}}
                                </td>
                                <td>
                                    {{itemRow.drivePathNm}}
                                    ({{itemRow.drivePathFromNm}} - {{itemRow.drivePathToNm}})
                                </td>

                                <!-- 시작일자 -->
                                <td>
                                    {{itemRow.getDtFromRowTxt() | filterDateTime:'yyyyMMdd'}}
                                </td>
                                <!-- 시작시간:미준수 -->
                                <ng-container *ngIf="hasErrSchedule(itemRow,'dur.schedule.row.diff.to');else durScheduleRowDiffTo">
                                    <td>
                                        <div class="text-danger" role="button"
                                            placement="top"
                                            data-html="true"
                                            [ngbTooltip]="errMsg"
                                            [closeDelay]="1000"
                                            container="body">
                                            {{itemRow.getDtFromRowTxt() | filterDateTime:'HHmm'}}
                                        </div>
                                    </td>
                                    <ng-template #errMsg>
                                        <div [innerHtml]="itemRow.msg['dur.schedule.row.diff.to']"></div>
                                    </ng-template>
                                </ng-container>
                                <!-- 시작시간:정상 -->
                                <ng-template #durScheduleRowDiffTo>
                                    <td>
                                        {{itemRow.getDtFromRowTxt() | filterDateTime:'HHmm'}}
                                    </td>
                                </ng-template>

                                <!-- 종료일자 -->
                                <td>
                                    {{itemRow.getDtToRowTxt() | filterDateTime:'yyyyMMdd'}}
                                </td>
                                <!-- 종료시간:미준수 -->
                                <ng-container *ngIf="hasErrSchedule(itemRow,'dur.schedule.row.diff.from');else durScheduleRowDiffFrom">
                                    <td role="button"
                                        class="text-danger"
                                        placement="top"
                                        data-html="true"
                                        [ngbTooltip]="errMsg"
                                        [closeDelay]="1000"
                                        container="body">
                                        <div>
                                            {{itemRow.getDtToRowTxt() | filterDateTime:'HHmm'}}
                                        </div>
                                    </td>
                                    <ng-template #errMsg>
                                        <div [innerHtml]="itemRow.msg['dur.schedule.row.diff.from']"></div>
                                    </ng-template>
                                </ng-container>
                                <!-- 종료시간:정상 -->
                                <ng-template #durScheduleRowDiffFrom>
                                    <td>
                                        {{itemRow.getDtToRowTxt() | filterDateTime:'HHmm'}}
                                    </td>
                                </ng-template>

                                <!-- 회차별 정보 -->
                                <ng-container *ngFor="let itemCnt of listDriveCnt;let idxCnt = index;">
                                    <ng-container *ngIf="itemRow.getDurMinuteTrip(itemCnt) > 0;else durDrive">
                                        <td class="border-left bg-light"
                                            role="button"
                                            placement="top"
                                            data-html="true"
                                            [ngbTooltip]="tripInfo"
                                            container="body">
                                            <div>
                                                {{itemRow.getDurMinuteTrip(itemCnt) | number}}
                                            </div>
                                            <ng-template #tripInfo>
                                                <div [innerHtml]="itemRow.getTxtTrip(itemCnt)"></div>
                                                <!-- <div [innerHtml]="itemRow.getTxtSchedule(itemCnt)"></div> -->
                                            </ng-template>
                                        </td>
                                    </ng-container>
                                    <ng-template #durDrive>
                                        <td class="border-left">
                                            <div>
                                                {{itemRow.getDurMinuteTrip(itemCnt) | number}}
                                            </div>
                                        </td>
                                    </ng-template>

                                    <ng-container *ngIf="hasErrRest(itemRow,itemCnt);else durRest">
                                        <td role="button"
                                            class="text-danger"
                                            placement="top"
                                            data-html="true"
                                            [ngbTooltip]="errMsg"
                                            [closeDelay]="1000"
                                            container="body"
                                            [class.bg-light]="itemRow.getDurMinuteTrip(itemCnt) > 0">
                                            <div>
                                                {{itemRow.getDurMinuteRest(itemCnt) | number}}
                                            </div>
                                            <ng-template #errMsg>
                                                <div [innerHtml]="getRestErrMsg(itemRow,itemCnt)"></div>
                                            </ng-template>
                                            <!-- <div [innerHtml]="itemRow.getTxtRest(itemCnt)"></div> -->
                                        </td>
                                    </ng-container>
                                    <ng-template #durRest>
                                        <td role="button"
                                            placement="top"
                                            data-html="true"
                                            [ngbTooltip]="restInfo"
                                            container="body"
                                            [class.bg-light]="itemRow.getDurMinuteTrip(itemCnt) > 0">
                                            <div>
                                                {{itemRow.getDurMinuteRest(itemCnt) | number}}
                                            </div>
                                            <ng-template #restInfo>
                                                <div [innerHtml]="itemRow.getTxtRest(itemCnt)"></div>
                                            </ng-template>
                                            <!-- <div [innerHtml]="itemRow.getTxtRest(itemCnt)"></div> -->
                                        </td>
                                    </ng-template>
                                </ng-container>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
